module.exports = __webpack_public_path__ + "static/media/menu-globe.f193b382.png";